export const $ = window.jQuery;
export default $;